import { TrialStatus } from "./creditHistoryModel";

const isEnabledFlag = (value: boolean | string | undefined): boolean => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }

  return false;
};

export const canUseTopUp = (trialStatus?: TrialStatus | null): boolean => {
  if (!trialStatus) {
    return false;
  }

  return isEnabledFlag(
    trialStatus.topup_enabled ?? trialStatus.trial_topup_enabled,
  );
};
